import * as React from "react";
import { Heading } from "../typography/heading/heading.mjs";
import { Icon } from "../icon/icon/icon.mjs";
const _InternetSpeed = class _InternetSpeed extends React.Component {
  isGlobal() {
    const { downSpeed, upSpeed, downUnit, upUnit, collapsed } = this.props;
    return downSpeed === upSpeed && downUnit.unit === upUnit.unit && collapsed === true;
  }
  BEM() {
    const classArray = ["internet-speed", "h4"];
    if (this.props.align) {
      classArray.push("internet-speed--" + this.props.align);
    }
    if (this.isGlobal()) {
      classArray.push("internet-speed--collapsed");
    }
    if (this.props.multiline && !this.props.collapsed) {
      classArray.push("internet-speed--multiline");
    }
    return classArray.join(" ");
  }
  renderSpeed(speed, unit) {
    return /* @__PURE__ */ React.createElement("span", { className: "internet-speed__speed" }, /* @__PURE__ */ React.createElement("span", { className: "h2 internet-speed__number" }, speed), /* @__PURE__ */ React.createElement("span", { className: "internet-speed__unit" }, unit.unit, /* @__PURE__ */ React.createElement("br", null), unit.direction));
  }
  getIcon(modifier) {
    return /* @__PURE__ */ React.createElement(Icon, { modifiers: modifier, className: "internet-speed__icon" });
  }
  getMultilineIcons() {
    return /* @__PURE__ */ React.createElement("span", { className: "internet-speed__directions" }, this.getIcon("#arrow-download"), this.getIcon("#arrow-upload"));
  }
  renderGlobalSpeed() {
    const { downSpeed, downUnit, upUnit } = this.props;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.getIcon("#arrow-up-down"), /* @__PURE__ */ React.createElement("span", { className: "internet-speed__speed" }, /* @__PURE__ */ React.createElement("span", { className: "h2 internet-speed__number" }, downSpeed), /* @__PURE__ */ React.createElement("span", { className: "internet-speed__unit" }, downUnit.unit, /* @__PURE__ */ React.createElement("br", null), downUnit.direction, "/", upUnit.direction)));
  }
  renderItems() {
    const { multiline, downSpeed, downUnit, upSpeed, upUnit } = this.props;
    if (this.isGlobal()) {
      return this.renderGlobalSpeed();
    } else {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "internet-speed__down" }, this.renderSpeed(downSpeed, downUnit)), !multiline && this.getIcon("#arrow-up-down"), /* @__PURE__ */ React.createElement("span", { className: "internet-speed__up" }, this.renderSpeed(upSpeed, upUnit)));
    }
  }
  render() {
    const { headingLevel } = this.props;
    return /* @__PURE__ */ React.createElement(Heading, { className: this.BEM(), level: headingLevel }, this.props.multiline && !this.props.collapsed && this.getMultilineIcons(), /* @__PURE__ */ React.createElement("span", { className: "internet-speed__items" }, this.renderItems()));
  }
};
_InternetSpeed.defaultProps = {
  headingLevel: 3
};
let InternetSpeed = _InternetSpeed;
export {
  InternetSpeed
};
